import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      redirect: '/Home'
    },
    {
      path: '/top',
      redirect: '/Home'
    },
    {
      path: '/Home',
      name: 'Home',
      component: ()=>import('@/views/Home/home')
    },
    {
      name:'AboutUs',
      path: '/AboutUs',
      component: ()=>import('@/views/AboutUs/aboutUs')
    },
    {
      name:'caseScenario',
      path: '/caseScenario',
      component: ()=>import('@/views/caseScenario/caseScenario')
    },
    {
      name:'login',
      path: '/login',
      component: ()=>import('@/views/login/login')
    },
    {
      name:'register',
      path: '/register',
      component: ()=>import('@/views/register/register')
    },
    // {
    //   path:"*",
    //   redirect:"/Home"
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js